import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const indexApi = createApi({
  reducerPath: 'indexApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_URL}/admin/search/`,
    mode: 'cors',
    prepareHeaders: (headers) => {
      const token = window.localStorage.getItem('accessToken');
      if (token) {
        headers.set('Authorization', `${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getStatus: builder.query({
      query: () => ({
        url: `health`
      }),      
    }),
  }),
})

export const { useGetStatusQuery } = indexApi